import { CanDeactivateFn } from '@angular/router';
import { SurveyFormComponent } from '../../pages/survey-form/survey-form.component';

export const surveyFormCanDeactivateGuard: CanDeactivateFn<SurveyFormComponent> = (component) => {
    return component.canDeactivateWithConfirm();
};
